import type { AiCostLimitPayload } from '@Application/AiCostLimits/Limits/Actions/aiCostLimitsFetched';

export type AiCostLimitCreatedAction = {
	type: 'AI_COST_LIMIT_CREATED';
	payload: AiCostLimitPayload;
	accountId: number;
};

export default (payload: AiCostLimitPayload, accountId: number): AiCostLimitCreatedAction => ({
	type: 'AI_COST_LIMIT_CREATED',
	payload,
	accountId,
});
